/**
 * Created by lizheng on 2018/6/6.
 */
//用于异步请求类似于redux中的异步
import { agreementInfo, ruleInfo } from '../service/index'
async function getAgreementInfo(commit,n){
  const res = await agreementInfo(n);
  if(res.status === 0){
    commit('INIT_AGREEMENT',res.data)
  }
}
async function getRuleInfo(commit,n){
  const res = await ruleInfo(n);
  if(res.status === 0){
    commit('SHOW_RULE',res.data.extra)
  }
}
export const displayAgreement = ({commit},n) => {
  commit('TOGGLE_AGREEMENT',true)
  getAgreementInfo(commit,n)
}
export const showRule = ({commit},n) => {
  getRuleInfo(commit,n)
}



// WEBPACK FOOTER //
// ./src/store/action.js